import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const companyRegistration = (data, navigate) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("auth/company-register", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
